import { createClient } from "@supabase/supabase-js";
import { clientOptions } from "./requests.ts";

// Both are safe in a browser bundle: the publishable key carries no schema
// privileges, and every table is protected by row level security, so what a
// signed-in user can reach is decided in the database rather than here.
const url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string;

if (!url || !key) {
  // Fail loudly at load rather than with a confusing network error later.
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set at build time",
  );
}

// Every request, the sign-in renewal included, has a time limit, and nothing is
// read from the database without a signed-in user's token: see requests.ts.
export const supabase = createClient(url, key, clientOptions(key));
